import { render, staticRenderFns } from "./DeliverySwitches.vue?vue&type=template&id=64a92f56&scoped=true"
import script from "./DeliverySwitches.vue?vue&type=script&lang=js"
export * from "./DeliverySwitches.vue?vue&type=script&lang=js"
import style0 from "./DeliverySwitches.vue?vue&type=style&index=0&id=64a92f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a92f56",
  null
  
)

export default component.exports